<!--
 * @Description:
 * @Author: 景 彡
 * @Date: 2024-10-30 10:33:30
 * @LastEditors: 景 彡
-->
<template>
  <a-tabs v-model:active-key="activeKey" centered>
    <a-tab-pane key="loginLog">
      <template #tab>
        <span>
          <c-icon-solution-outlined />
          登录日志
        </span>
      </template>
      <c-pro-table
        :columns="loginLogColumns"
        :api="api.ClientUserManage.LoginLogList_GetAsync"
        row-key="id"
        immediate
        serial-number
        align="center"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'userName'">
            <a @click="showDrawer(record.userId)">{{ record.userName }}</a>
          </template>
        </template>
      </c-pro-table>
    </a-tab-pane>
    <a-tab-pane v-for="item in requestLogData" :key="item.name">
      <template #tab>
        <span>
          <c-icon-pull-request-outlined />
          {{ item.name }}
        </span>
      </template>
      <c-pro-table
        v-if="item.name === '返现日志'"
        ref="cashbackTableRef"
        v-model:search-form="cashbackSearchForm"
        :columns="item.columns"
        :api="item.api"
        row-key="id"
        immediate
        serial-number
        align="center"
      />
      <c-pro-table
        v-else
        :columns="item.columns"
        :api="item.api"
        row-key="id"
        immediate
        serial-number
        align="center"
      />
    </a-tab-pane>
  </a-tabs>
</template>

<script lang="tsx" setup>
import * as api from '@/.generated/apis'
import { CashbackRecordStatus } from '@/api/models'
import { nextTick, onMounted, reactive, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { loginLogColumns, requestLogData } from './columns.tsx'

definePage({
  meta: {
    title: '日志管理',
  },
})

const route = useRoute()

const activeKey = ref<string>('loginLog')
const cashbackTableRef = ref<any>(null)
const cashbackSearchForm = reactive<{ status: CashbackRecordStatus | null }>({
  status: null,
})

function applyRouteQuery() {
  const tab = route.query.tab as string | undefined
  if (tab) {
    const matched = requestLogData.find(item => item.name === tab)
    if (matched) {
      activeKey.value = matched.name
    }
  }

  const status = route.query.status
  if (status !== undefined && status !== null && status !== '') {
    const statusValue = Number(status)
    if (!Number.isNaN(statusValue) && statusValue in CashbackRecordStatus) {
      cashbackSearchForm.status = statusValue as CashbackRecordStatus
      nextTick(() => {
        cashbackTableRef.value?.search?.()
      })
    }
  }
}

onMounted(applyRouteQuery)

watch(() => route.query, applyRouteQuery)

function showDrawer(userId: number) {
  console.log('%c [ userId ]-40', 'font-size:13px; background:pink; color:#bf2c9f;', userId)
}
</script>
